// extracted by mini-css-extract-plugin
module.exports = {"scrollingContainer":"_2OKDR","pillsContainer":"_3k0mY"};